(function () {
  "use strict";

  const SELECTORS = {
    lightboxSrc: "[data-lightbox-src]",
  };

  const CLASSES = {
    overlayActive: "is-active",
    bodyLock: "lightbox-open",
  };

  class ProductLightbox extends HTMLElement {
    constructor() {
      super();
      this.overlay = null;
      this.scrollContainer = null;
      this.imageWraps = [];
      this.images = [];
      this.boundOnKeyDown = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      this.images = Array.from(this.querySelectorAll(SELECTORS.lightboxSrc));
      if (this.images.length === 0) return;

      this.images.forEach((img, index) => {
        img.addEventListener("click", (e) => {
          e.preventDefault();
          this.open(index);
        });

        img.addEventListener("keyup", (e) => {
          if (e.code === "Enter") {
            e.preventDefault();
            this.open(index);
          }
        });
      });
    }

    buildOverlay() {
      if (this.overlay) return;

      const overlay = document.createElement("div");
      overlay.className = "lightbox__overlay";
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.setAttribute("aria-label", "Image lightbox");
      overlay.setAttribute("tabindex", "0");

      /* Close button */
      const closeBtn = document.createElement("button");
      closeBtn.className = "lightbox__close";
      closeBtn.type = "button";
      closeBtn.setAttribute("aria-label", "Close lightbox");
      closeBtn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>`;
      closeBtn.addEventListener("click", () => this.close());

      /* Scrollable image container */
      const scroll = document.createElement("div");
      scroll.className = "lightbox__scroll";

      this.imageWraps = this.images.map((source) => {
        const wrap = document.createElement("div");
        wrap.className = "lightbox__image-wrap";

        const img = document.createElement("img");
        img.className = "lightbox__image";
        img.alt = source.querySelector("img")?.alt ?? "";
        img.loading = "lazy";
        img.setAttribute("data-src", source.getAttribute("data-lightbox-src"));

        wrap.appendChild(img);
        scroll.appendChild(wrap);
        return wrap;
      });

      overlay.appendChild(closeBtn);
      overlay.appendChild(scroll);

      document.body.appendChild(overlay);

      this.overlay = overlay;
      this.scrollContainer = scroll;
    }

    open(index) {
      this.buildOverlay();
      this.loadAllImages();
      this.overlay.classList.add(CLASSES.overlayActive);
      document.body.classList.add(CLASSES.bodyLock);
      document.addEventListener("keydown", this.boundOnKeyDown);

      /* Scroll to the clicked image and focus overlay for keyboard scrolling */
      requestAnimationFrame(() => {
        const target = this.imageWraps[index];
        if (target) {
          this.overlay.scrollTop = target.offsetTop;
        }
        this.overlay.focus();
      });
    }

    close() {
      if (!this.overlay) return;
      this.overlay.classList.remove(CLASSES.overlayActive);
      document.body.classList.remove(CLASSES.bodyLock);
      document.removeEventListener("keydown", this.boundOnKeyDown);
    }

    loadAllImages() {
      const imgs = this.overlay.querySelectorAll(".lightbox__image[data-src]");
      imgs.forEach((img) => {
        const src = img.getAttribute("data-src");
        if (src && !img.src) {
          img.src = src;
        }
      });
    }

    onKeyDown(e) {
      if (e.key === "Escape") {
        e.preventDefault();
        this.close();
      }
    }

    disconnectedCallback() {
      document.removeEventListener("keydown", this.boundOnKeyDown);
      if (this.overlay) {
        this.overlay.remove();
        this.overlay = null;
      }
    }
  }

  if (!customElements.get("product-lightbox")) {
    customElements.define("product-lightbox", ProductLightbox);
  }
})();
